import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import {faChartLine, faTimes} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import moment from "moment";

//https://github.com/FortAwesome/vue-fontawesome
library.add(faTimes)
library.add(faChartLine)
Vue.component('font-awesome-icon', FontAwesomeIcon)
,
Vue.config.productionTip = false

moment.locale('de');


Vue.filter('moment', (date: moment.MomentInput) => moment(date).format('ll'));


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

